<!-- @format -->

<template>
	<border-box>
		<div :class="isHeight ? 'appSwitch appHeightMax' : 'appSwitch'">
			<div class="appSwitchAll work-img-border">
				<div class="appSwitchTop">
					<el-row>
						<el-col :span="23">
							<span class="title">应用管理</span>
						</el-col>
						<el-col class="setting" :span="1">
							<!-- 暂时隐藏设置按钮 -->
							<!-- <el-icon @click="showDialog"><Setting /></el-icon> -->
						</el-col>
					</el-row>
				</div>
				<!-- 一行显示五条数据，多余的自动换行，从第二行再开始排列 -->
				<el-carousel
					v-if="isShowCarousel"
					trigger="click"
					height="100%"
					:autoplay="false"
					indicator-position="none"
					:arrow="carouselTotal > 1 ? 'always' : 'never'"
				>
					<el-carousel-item v-for="itemYe in carouselTotal" :key="itemYe">
						<el-row class="appSwitchContent" :gutter="20">
							<el-col v-for="item in divisionArray[itemYe - 1]" :key="item.alias" :span="25" @click="goToSystem(item)">
								<div class="appCenter">
									<div class="appSwitchIcon">
										<img v-if="item.logo" :src="item.logo" class="app-switch-logo" />
										<!-- <img v-else src="@/assets/images/add-btn.png" class="app-switch-logo" /> -->
									</div>
									<div class="appIconName">{{ item.name }}</div>
								</div>
							</el-col>
						</el-row>
					</el-carousel-item>
				</el-carousel>
			</div>
		</div>
		<!-- 对话框 -->
		<el-dialog
			v-model="dialogVisible"
			:close-on-click-modal="false"
			append-to-body
			title="应用展示排序"
			width="50%"
			:before-close="dialogCancel"
			custom-class="appSwitchDialog"
			class="app"
		>
			<div ref="targetContent" class="listItem">
				<div
					v-for="(item, index) in transferData"
					:key="index"
					class="itemCenter"
					:draggable="true"
					@dragstart="(e) => dragstart(e, index)"
					@drop="(e) => drop(e, index)"
					@dragover="(e) => dragover(e, index)"
				>
					<div class="itemIcon">
						<img v-if="item.logo" :src="item.logo" class="app-switch-logo" />
					</div>
					<div class="itemText">{{ item.label }}</div>
				</div>
			</div>

			<template #footer>
				<span class="dialog-footer">
					<el-button @click="dialogCancel">取消</el-button>
					<el-button type="primary" @click="dialogDetermine">确定</el-button>
				</span>
			</template>
		</el-dialog>
		<div v-show="isWorkbenchedit" class="delEdit">
			<el-icon style="margin-right: 10px" @click="showDialog"><icon-ant-design:setting-outlined /></el-icon>
			<el-icon @click="delEdit"><icon-ant-design:delete-outlined /></el-icon>
		</div>
	</border-box>
</template>

<script setup name="appSwitch">
	import { ref } from 'vue';
	import { useGlobalStoreWithOut } from '@power/runtime-vue3';
	import borderBox from './border-box.vue';
	import { toSubSystem } from '@/p-components/pcp-my-systems/utils';

	const emit = defineEmits(['deletePanelItemEvent', 'selectItemEvent']);
	const props = defineProps({
		isHeight: {
			type: [Boolean],
		},
		isWorkbenchedit: {
			type: [Boolean],
		},
		id: {
			type: [Number, String],
		},
		editArray: {
			type: [Array],
		},
	});
	const workTypeList = ref([]);
	// 走马灯页数
	const carouselTotal = ref(1);
	// 控制走马灯显隐
	const isShowCarousel = ref(false);
	// 控制模态框显隐
	const dialogVisible = ref(false);
	// 穿梭框的数据
	const transferData = ref([]);
	// 穿梭框中选中的值
	const transferValue = ref(props.editArray && props.editArray.length ? props.editArray : []);
	// 根据穿梭框的选择动态渲染展示的数据
	const serviceList = ref([]);

	// 将分割后展示的数据
	const divisionArray = ref([]);

	function delEdit() {
		emit('deletePanelItemEvent', props.id);
	}

	// 鼠标拖拽
	function dragstart(e, index) {
		e.dataTransfer.setData('index', index);
	}
	function dragover(e) {
		e.preventDefault();
	}
	function drop(e, index) {
		e.preventDefault();
		const startIndex = parseInt(e.dataTransfer.getData('index'));
		const currentIndex = parseInt(index);
		if (startIndex - currentIndex > 0) {
			transferData.value.splice(currentIndex, 0, transferData.value[startIndex]);
			transferData.value.splice(startIndex + 1, 1);
		} else if (startIndex - currentIndex < 0) {
			transferData.value.splice(currentIndex + 1, 0, transferData.value[startIndex]);
			transferData.value.splice(startIndex, 1);
		}
	}

	// 将数组分割成多个小数组
	function group(array, subGroupLength) {
		let index = 0;
		const newArray = [];
		while (index < array.length) {
			newArray.push(array.slice(index, (index += subGroupLength)));
		}
		divisionArray.value = newArray;
		carouselTotal.value = newArray.length ? newArray.length : 1;
		isShowCarousel.value = true;
	}

	function onceList() {
		const globalStore = useGlobalStoreWithOut();
		{
			const userService = globalStore.subSystems.map((item) => {
				return {
					...item,
					code: item.alias,
					disabled: false,
				};
			});
			userService.push({
				id: 'addApp',
				name: '添加应用',
			});
			workTypeList.value = userService;
			const data = [];
			transferValue.value.forEach((res) => {
				workTypeList.value.map((item) => {
					if (item.code === res) {
						data.push(item);
					}
				});
			});
			// 判断已选数据与总数不同
			const result = [];
			for (let i = 0; i < workTypeList.value.length; i++) {
				const obj = workTypeList.value[i];
				const num = obj.code;
				let isExist = false;
				for (let j = 0; j < transferValue.value.length; j++) {
					const aj = transferValue.value[j];
					const n = aj;
					if (n == num) {
						isExist = true;
						break;
					}
				}
				if (!isExist) {
					result.push(obj);
				}
			}
			serviceList.value = data.concat(result);
			transferData.value = generateData();
			group(serviceList.value, 20);
		}
	}

	// 渲染要展示的数据
	function generateData() {
		const data = [];
		const workTypes = serviceList.value;
		for (let i = 0; i < workTypes.length; i++) {
			data.push({
				key: workTypes[i].code,
				label: workTypes[i].name,
				disabled: workTypes[i].disabled,
				icon: workTypes[i].icon,
				logo: workTypes[i].logo,
			});
		}
		return data;
	}

	// 显示对话框
	function showDialog() {
		dialogVisible.value = true;
	}

	// 跳转到其他系统
	function goToSystem(item) {
		if (!props.isWorkbenchedit) {
			if (item.id !== 'addApp' && item.homePage !== '#') {
				toSubSystem(item);
			} else {
				if (item.homePage === '#') {
					ElMessage.warning('应用建设中...');
				}
			}
		}
	}

	// 对话框确定按钮
	function dialogDetermine() {
		const data = [];
		let changedData = [];
		changedData = transferData.value.map((item) => item.key);
		const selectItemEvent = {
			selectList: changedData,
			// module: '切换应用空间',
			module: props.id,
		};
		emit('selectItemEvent', selectItemEvent);
		changedData.forEach((res) => {
			workTypeList.value.map((item) => {
				if (item.code === res) {
					data.push(item);
				}
			});
		});
		serviceList.value = data;
		group(serviceList.value, 20);
		dialogVisible.value = false;
	}

	// 对话框取消按钮
	function dialogCancel() {
		transferData.value = serviceList.value.map((item) => ({
			key: item.code,
			label: item.name,
			disabled: item.disabled,
			icon: item.icon,
			logo: item.logo,
		}));
		dialogVisible.value = false;
	}

	onceList();
</script>

<style scoped lang="scss">
	// @import '@/assets/styles/base/base-variables.module.scss';

	.delEdit {
		position: absolute;
		top: 20px;
		right: 25px;
		// font-size: $app-fontsize-title;

		.el-icon {
			// color: $theme-workbench-icon-color;
			cursor: pointer;
		}
	}

	.appSwitch {
		height: 100%;

		.appSwitchAll {
			height: 100%;
		}

		.appSwitchTop {
			.title {
				font-weight: 600;
				font-size: 16px;
				color: #ffffff;
				line-height: 20px;

				&::before {
					content: '';
					display: inline-block;
					width: 3px;
					height: 18px;
					background: #5eebff;
					border-radius: 2px;
					margin-right: 5px;
					vertical-align: middle;
					margin-top: -4px;
				}
			}

			.setting {
				text-align: right;

				.el-icon {
					// color: $theme-workbench-title-color;
					cursor: pointer;
				}
			}
		}

		:deep(.el-carousel__indicators--horizontal) {
			display: none;
		}

		:deep(.el-carousel__item) {
			display: flex;
			align-items: flex-start;
			justify-content: center;
		}

		:deep .el-carousel__arrow {
			width: 25px;
			border-radius: 0;
			font-size: 24px;

			.el-icon {
				color: #fff;
			}
		}

		:deep(.el-carousel__arrow--left) {
			left: 0px;
		}

		:deep(.el-carousel__arrow--right) {
			right: 0px;
		}

		:deep .el-carousel {
			height: 97%;

			.el-carousel__container {
				height: 100%;
			}
		}

		.appSwitchContent {
			padding: 0;
			width: 100%;

			:deep .el-col-25 {
				color: #fff;
				width: 20%;
				cursor: pointer;
			}

			.appCenter {
				cursor: pointer;
				// background: url('@/assets/images/app-bg.png') no-repeat;
				background-size: 100% 100%;
				display: flex;
				align-items: center;
				justify-content: flex-start;
				padding: 20px;
				height: 80px;
				margin-bottom: 20px;

				img {
					width: 40px;
					margin-right: 10px;
				}

				.appIconName {
					font-weight: 500;
					font-size: 16px;
					color: #ffffff;
					line-height: 16px;
				}
			}
		}
	}

	.listItem {
		height: 378px;
		overflow: auto;

		.itemCenter {
			display: inline-block;
			width: 20%;
			height: 98px;
			text-align: center;
			cursor: pointer;

			.itemIcon {
				display: inline-block;
				height: 65px;
				line-height: 80px;
				width: 100%;
				max-width: 10rem;
				margin-bottom: 10px;
				background-size: 70% 100%;

				.app-switch-logo {
					height: 60px;
					margin-bottom: 30px;
				}

				.el-icon {
					// color: $theme-workbench-title-color;
					font-size: 40px;
				}

				.svg-icon {
					// color: $theme-workbench-title-color;
					font-size: 40px;
				}
			}

			.itemText {
				display: inline-block;
				height: 22px;
				width: 100%;
				max-width: 10rem;
				text-align: center;
				// color: $theme-workbench-title-color;
				font-size: 1.4rem;
			}
		}

		.itemCenter:hover {
			.itemIcon {
				background-size: 70% 100%;

				.el-icon {
					// color: $theme-workbench-icon-hover-color;
				}

				.svg-icon {
					// color: $theme-workbench-icon-hover-color;
				}
			}

			.itemText {
				// color: $theme-workbench-icon-hover-color;
			}
		}
	}
</style>
<style lang="scss">
	.appSwitchDialog {
		//background: #031233 !important;
		//border: 2px solid $theme-workbench-title-color;

		.el-dialog__header {
			.el-dialog__title {
				// color: $theme-workbench-calendar-color;
			}

			.el-icon {
				// color: $theme-workbench-calendar-color;
			}
		}

		.el-dialog__body {
			margin: 0 15px;
		}
	}
</style>
